import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      }
    }

    range.forEach((i) => {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2 mt-8">
      {/* Previous Button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`
          w-10 h-10 flex items-center justify-center rounded-lg transition-all duration-200
          ${
            currentPage === 1
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-white text-primary-500 hover:bg-primary-500 hover:text-white border border-gray-200 hover:border-primary-500 shadow-sm hover:shadow-md"
          }
        `}
      >
        <i className="fas fa-chevron-left text-sm"></i>
      </button>

      {/* Page Numbers */}
      {getPageNumbers().map((page, index) => (
        <button
          key={index}
          onClick={() => page !== "..." && onPageChange(page)}
          disabled={page === "..."}
          className={`
            min-w-[40px] h-10 px-2 flex items-center justify-center rounded-lg transition-all duration-200
            ${
              page === currentPage
                ? "bg-primary-500 text-white font-semibold shadow-md"
                : page === "..."
                  ? "bg-transparent text-gray-500 cursor-default"
                  : "bg-white text-gray-700 hover:bg-primary-100 hover:text-primary-600 border border-gray-200 hover:border-primary-300 shadow-sm hover:shadow"
            }
          `}
        >
          {page}
        </button>
      ))}

      {/* Next Button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`
          w-10 h-10 flex items-center justify-center rounded-lg transition-all duration-200
          ${
            currentPage === totalPages
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-white text-primary-500 hover:bg-primary-500 hover:text-white border border-gray-200 hover:border-primary-500 shadow-sm hover:shadow-md"
          }
        `}
      >
        <i className="fas fa-chevron-right text-sm"></i>
      </button>
    </div>
  );
};

export default Pagination;
